import React from 'react'
import { Container, Row, Col } from 'react-awesome-styled-grid'

import CardModule from '../components/CardModule'
import { Section, SectionHeading, SectionContent } from '../components/Section'
import Title from '../components/Title'
import modules from '../mocks/modules'

const Buy = () => (
  <Section
    id="quero-comprar"
    bgImage="/images/bg-buy.jpg"
    paddingTop={140}
    paddingBottom={140}
    fluid
  >
    <Container className="h-100">
      <Row
        justify={{
          xs: 'center',
          md: 'flex-end',
        }}
        align="center"
        className="h-100"
      >
        <Col sm={9} md={7} lg={6}>
          <SectionHeading marginBottom={40}>
            <Title
              color="light"
              appearance="section"
              data-sal="slide-right"
              data-sal-delay="300"
              data-sal-easing="ease"
              data-sal-duration="800"
            >
              <span className="highlight-primary">Quero comprar</span>
            </Title>
          </SectionHeading>
          <SectionContent>
            <Row>
              {modules.map(({ label, title, action, totalPrice, price }, i) => (
                <Col key={i} xs={12} sm={6}>
                  <CardModule
                    label={label}
                    title={title}
                    action={action}
                    totalPrice={totalPrice}
                    price={price}
                    marginBottom={32}
                    showPrice
                    ghost
                    data-sal="slide-down"
                    data-sal-delay={i * 100 + 400}
                    data-sal-easing="ease"
                    data-sal-duration="800"
                  />
                </Col>
              ))}
            </Row>
          </SectionContent>
        </Col>
      </Row>
    </Container>
  </Section>
)

export default Buy
